var map = {
	"./br.json": "d542",
	"./de.json": "02a8",
	"./el.json": "e069",
	"./en.json": "e90f",
	"./es.json": "95e0",
	"./it.json": "7ad6",
	"./ko.json": "8667",
	"./ru.json": "6e23",
	"./sl.json": "5265",
	"./tr.json": "b5ae",
	"./us.json": "dd89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "119d";